'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useColorScheme } from '#pplx/frontend/aether/hooks/useColorScheme.js';
import { resolveSpaceIcon } from '#pplx/frontend/apps/ask/collections/resolveSpaceIcon.js';
import { SpaceIconGlyph } from '#pplx/frontend/apps/ask/collections/SpaceIconGlyph.js';
import React from 'react';
const SIZE_CLASSES = {
    small: 'size-4',
    medium: 'size-6',
    large: 'size-10',
    xlarge: 'size-14',
};
const EMOJI_SIZE = {
    small: 'tiny',
    medium: 'regular',
    large: 'regular',
    xlarge: 'large',
};
const ICON_SIZE = {
    small: 'small',
    medium: 'default',
    large: 'large',
    xlarge: 'large',
};
export const ResolvedSpaceIcon = ({ presentation, size }) => {
    return (_jsx("div", { className: `flex-none flex items-center justify-center ${SIZE_CLASSES[size]}`, children: _jsx(SpaceIconGlyph, { presentation: presentation, iconSize: ICON_SIZE[size], emojiSize: EMOJI_SIZE[size], appearanceClassName: "flex items-center justify-center" }) }));
};
export const SpaceIcon = ({ space, size }) => {
    const { colorScheme } = useColorScheme();
    return _jsx(ResolvedSpaceIcon, { presentation: resolveSpaceIcon(space, colorScheme), size: size });
};
//# sourceMappingURL=SpaceIcon.js.map